/* ZYRE Hybrid prototype — namespaced, no dependencies. */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.zy-rv, .zy-sc');
    if (!els.length) return;
    if (RM || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }

  /* Finish radio groups: click + full keyboard support (arrows, Home, End). */
  function finishes() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zy-finish-group]'), function (group) {
      if (group.hasAttribute('data-zy-bound')) return;
      group.setAttribute('data-zy-bound', 'true');

      var scope = document.getElementById(group.getAttribute('data-zy-scope'));
      if (!scope) return;
      var img = scope.querySelector('[data-zy-finish-image]');
      var field = scope.closest('[data-zy-finish-field]') || scope;
      var link = scope.querySelector('[data-zy-finish-link]');
      var radios = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));

      /* Swap both srcset and src. A present srcset always wins over src, so
         updating src alone leaves the original image on screen. */
      function swap(src, srcset, alt) {
        if (!img || !src) return;
        if (srcset) { img.setAttribute('srcset', srcset); } else { img.removeAttribute('srcset'); }
        img.setAttribute('src', src);
        if (alt) { img.setAttribute('alt', alt); }
      }

      function select(b, focus) {
        radios.forEach(function (o) {
          var on = o === b;
          o.setAttribute('aria-checked', String(on));
          o.setAttribute('tabindex', on ? '0' : '-1');
        });
        if (focus) b.focus();

        var src = b.getAttribute('data-zy-img');
        var srcset = b.getAttribute('data-zy-srcset');
        var alt = b.getAttribute('data-zy-alt');
        if (img && src && img.getAttribute('src') !== src) {
          if (RM) {
            swap(src, srcset, alt);
          } else {
            img.style.opacity = '0';
            window.setTimeout(function () {
              swap(src, srcset, alt);
              img.style.opacity = '1';
            }, 200);
          }
        }

        var col = b.getAttribute('data-zy-color');
        if (col) field.style.setProperty('--zy-field', col);
        var tint = b.getAttribute('data-zy-tint');
        if (tint) field.style.background = tint;
        var href = b.getAttribute('data-zy-href');
        if (link && href) link.setAttribute('href', href);
      }

      group.addEventListener('click', function (ev) {
        var b = ev.target.closest('[role="radio"]');
        if (b) select(b, false);
      });

      group.addEventListener('keydown', function (ev) {
        var i = radios.indexOf(document.activeElement);
        if (i < 0) return;
        var n = null;
        if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') n = radios[(i + 1) % radios.length];
        else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') n = radios[(i - 1 + radios.length) % radios.length];
        else if (ev.key === 'Home') n = radios[0];
        else if (ev.key === 'End') n = radios[radios.length - 1];
        else if (ev.key === ' ' || ev.key === 'Enter') { ev.preventDefault(); select(radios[i], true); return; }
        if (n) { ev.preventDefault(); select(n, true); }
      });
    });
  }

  /* Mobile nav: Escape closes, focus is contained, focus returns to the trigger. */
  function nav() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zy-nav-toggle]'), function (btn) {
      if (btn.hasAttribute('data-zy-bound')) return;
      btn.setAttribute('data-zy-bound', 'true');

      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var SEL = 'a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])';

      function open(state) {
        panel.hidden = !state;
        panel.setAttribute('data-open', String(state));
        btn.setAttribute('aria-expanded', String(state));
        if (state) {
          var f = panel.querySelector(SEL);
          if (f) f.focus();
        } else {
          btn.focus();
        }
      }

      btn.addEventListener('click', function () {
        open(btn.getAttribute('aria-expanded') !== 'true');
      });

      document.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Escape') return;
        if (btn.getAttribute('aria-expanded') === 'true') { ev.preventDefault(); open(false); }
      });

      panel.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Tab') return;
        var f = Array.prototype.slice.call(panel.querySelectorAll(SEL)).filter(function (el) {
          return el.offsetParent !== null;
        });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
        else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
      });
    });
  }

  /* Dimensional scaling. Only applied when verified heights produce a ratio. */
  function scale() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zy-scale]'), function (img) {
      var r = parseFloat(img.getAttribute('data-zy-scale'));
      if (!isNaN(r) && r > 0 && r <= 100) img.style.width = r.toFixed(1) + '%';
    });
  }

  function init() { reveal(); finishes(); nav(); scale(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
